<template>
    <div>
        <v-server-table ref="safetyDataSheetTable" url="/safety-data-sheets/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div class="float-left" v-if="showFilters">
                    <table-filters-2 ref="sdsTableFilters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" filterUrl="/safety-data-sheets/filters" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <b-form-select v-model="slotProps.filters['safety_data_sheets.is_active']" size="sm" :options="[{value: null, text: '-- Show Active/Inactive --'}, {value: 0, text: 'Inactive'}, {value: 1, text: 'Active'}]"></b-form-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button class="btn btn-outline-success ml-md-2 ml-0" v-on:click="openModal = true" v-if="showAddBtn">
                    <i class="fa fa-plus-circle"></i> {{ assetId ? 'Edit' : 'Add' }} Jobsite Data Sheets
                </button>
                <button class="btn btn-secondary" v-on:click="exportDataSheets()" v-if="assetType == 'Jobsite'" :disabled="exporting" title="Export all this jobsite's Safety Data Sheets into a ZIP file for printing, or storing on a local computer.">
                    <template v-if="exporting">
                        <i class="fa fa-spin fa-spinner"></i> Exporting
                    </template>
                    <template v-else>
                        <i class="fa fa-file-zip-o"></i> Export .ZIP
                    </template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="id" slot-scope="props">
                <b-dropdown html='<i class="fa fa-ellipsis-h"></i>' variant="default" :no-flip="true" size="sm">
                    <b-dropdown-item href="javascript:void(0)" v-on:click="$router.push(`/safety-data-sheets/view/${props.row.id}`)" title="View Safety Data Sheet"><i class="fa fa-eye"></i> View</b-dropdown-item>
                    <template v-if="$root.hasPermission('safety.data_sheets.manage')">
                        <b-dropdown-item href="javascript:void(0)" v-on:click="$router.push(`/safety-data-sheets/edit/${props.row.id}`)" title="Edit Safety Data Sheet">
                            <i class="fa fa-edit"></i> Edit
                        </b-dropdown-item>
                        <b-dropdown-item href="javascript:void(0)" v-on:click="$router.push(`/safety-data-sheets/delete/${props.row.id}`)" title="Delete Safety Data Sheet">
                            <i class="fa fa-trash text-danger"></i> Delete
                        </b-dropdown-item>
                    </template>
                </b-dropdown>
            </template>

            <template slot="catalog_name" slot-scope="props">
                <template v-if="edit_jobsite_sheet_id == null || edit_jobsite_sheet_id !== props.row.jobsite_sheet_id">
                    {{ props.row.catalog_name ? props.row.catalog_name : '--' }}
                    <button type="button" class="btn btn-sm btn-link" @click="editCatalog(props.row.jobsite_sheet_id)" v-if="canManageJobsites" title="Edit Catalog"><i class="fa fa-edit"></i></button>
                </template>
                <template v-else>
                    <div class="form-inline">
                        <div class="form-group">
                            <b-form-select :value="props.row.catalog_id" :options="catalogOptions" @change="updateCatalog" size="sm" class="mr-1" />
                            <button type="button" class="btn btn-sm btn-secondary" @click="resetEditCatalog()"><i class="fa fa-remove"></i></button>
                        </div>
                    </div>

                    <div class="form-inline mt-1" v-show="new_catalog">
                        <div class="form-group">
                            <b-form-input placeholder="Enter New Catalog Name" v-model="new_catalog_name" size="sm" class="mr-1" />
                            <button type="button" class="btn btn-sm btn-success" @click="saveNewCatalog()"><i class="fa fa-check"></i></button>
                        </div>
                    </div>
                </template>
            </template>

            <router-link slot="data_sheet_name" slot-scope="props" :to="`/safety-data-sheets/view/${props.row.id}`" title="View Safety Data Sheet">
                {{ props.row.data_sheet_name }}
            </router-link>

            <template slot="current_file_id" slot-scope="props">
                <a :href="`/files/view/${props.row.current_file_id}`" target="_blank" title="View or Download File in a New Tab">{{ props.row.file_name }}</a>
            </template>

            <template slot="is_active" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                <label class="badge badge-warning" v-else>Inactive</label>
            </template>

            <!-- <template slot="child_row" slot-scope="props">

            </template> -->

        </v-server-table>

        <b-modal
            ref="actionModal"
            v-model="openModal"
            title="Attach Safety Data Sheet(s) to a Jobsite"
            size="lg"
            ok-title="Attach Data Sheet(s)"
            ok-variant="success"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            @shown="handleShown" :no-close-on-backdrop="true">

            <div v-if="loading">
                <i class="fa fa-spin fa-spinner"></i> Loading
            </div>
            <div v-else>
                <div v-bind:class="{ 'form-group': true, 'has-error': errors.jobsite_id }" class="row">
                    <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">
                        Jobsite:
                        <i class="fa fa-asterisk text-danger"></i>
                    </label>
                    <div class="col-md-8 col-sm-12">
                        <jobsite-select ref="jobsiteSelect" :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false"></jobsite-select>

                        <div v-if="errors.jobsite_id" class="text-danger">
                            <span v-for="error in errors.jobsite_id">{{ error }}</span>
                        </div>
                    </div>
                </div>

                <div v-bind:class="{ 'form-group': true, 'has-error': errors.sheets }" class="row">
                    <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.sheets}">
                        Safety Data Sheets ({{ jobsiteSheets.length }}):
                        <i class="fa fa-asterisk text-danger"></i>

                        <div v-if="errors.sheets" class="text-danger mt-2 mb-2">
                            <span v-for="error in errors.sheets">{{ error }}</span>
                        </div>
                    </label>
                    <div class="col-md-8 col-sm-12">
                        <div v-if="!jobsite.JobsiteId" class="mt-2">-- Select a Jobsite to Load Data Sheet --</div>
                    </div>
                </div>

                <div class="col-md-10 offset-md-1" :style="`max-height: ${scrollHeight}px; overflow-y: auto;`">

                    <b-form-checkbox v-model="select_all" :value="true" :unchecked-value="false" v-on:change="toggleSelectAll()" plain>Select All</b-form-checkbox>
                    <hr/>

                    <b-form-checkbox-group v-model="jobsiteSheets" plain stacked :disabled="!jobsite.JobsiteId">

                        <b-form-checkbox :value="sheet.id" v-for="sheet in sheets" :key="sheet.id">
                            <span class="d-block mb-2">
                                {{ sheet.data_sheet_name }}
                                <span class="d-inline-block ml-1" style="width: 200px;" v-if="jobsiteSheets.includes(sheet.id)">
                                    <b-form-select v-model="sheet.catalog_id" :options="bulkCatalogEditOptions" size="sm" />
                                </span>
                            </span>
                        </b-form-checkbox>

                    </b-form-checkbox-group>
                </div>
            </div>

            <template slot="modal-footer">
                <button class="btn btn-secondary" @click="openModal = false">
                    Cancel
                </button>
                <button class="btn btn-success" @click="handleOk()" :disabled="saving">
                    Attach Data Sheet(s)
                </button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: {
            assetType: {
                type: String,
            },

            assetId: {
                type: Number,
            },

            showAddBtn: {
                type: Boolean,
                default: false,
            },

            showFilters: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                select_all: false,

                options: {
                    headings: {
                        id: 'Actions',
                        catalog_name: 'Catalog',
                        data_sheet_name: 'Data Sheet',
                        manufacturer_name: 'Manufacturer',
                        supplier_name: 'Supplier',
                        product_code: 'Product Code',
                        cas_nbr: 'CAS#',
                        current_file_id: 'File',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'safety_data_sheets.data_sheet_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('sdsListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        if(this.showFilters)
                        {
                            //Append
                            data.filters = filterExtractor.extractFilters(this.filters);
                        }

                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                canManageJobsites: this.$root.hasPermission(['jobsites.manage']),
                edit_jobsite_sheet_id: null,
                new_catalog: false,
                new_catalog_name: null,
                openModal: false,
                loading: true,
                saving: false,
                edit_catalog_loading: false,
                exporting: false,
                jobsite_id: null,
                jobsite: {},
                jobsiteSheets: [],
                catalogs: [],
                sheets: [],
                errors: {},

                filterDefs: {
                    'safety_data_sheets.is_active': 1,
                },

                filterKey: 'sdsFilters',
            }
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            columns(){
                //Setup
                var columns = ['id', 'data_sheet_name', 'manufacturer_name', 'supplier_name', 'product_code', 'cas_nbr', 'current_file_id', 'is_active'];

                //IF jobsite asset, add the catalog column
                if(this.assetType === 'Jobsite')
                {
                    columns = ['id', 'catalog_name', 'data_sheet_name', 'manufacturer_name', 'supplier_name', 'product_code', 'cas_nbr', 'current_file_id', 'is_active'];
                }

                //Send it
                return columns;
            },

            catalogOptions(){
                //Setup
                var options = [
                    { value: null, text: '-- Select a Catalog or Leave Blank to None --' },
                ];

                //Loop and Build
                for (var i = 0; i < this.catalogs.length; i++)
                {
                    //Append
                    options.push({value: this.catalogs[i].id, text: this.catalogs[i].catalog_name});
                }

                //Append New
                options.push({value: 'NEW', text: '-- Create New Catalog --'});

                //Send it
                return options;
            },

            bulkCatalogEditOptions(){
                //Setup
                var options = [
                    { value: null, text: '-- No Catalog --' },
                ];

                //Loop and Build
                for (var i = 0; i < this.catalogs.length; i++)
                {
                    //Append
                    options.push({value: this.catalogs[i].id, text: this.catalogs[i].catalog_name});
                }

                //Send it
                return options;
            },

            sheetOptions(){
                //Setup
                var options = [];

                //Loop
                for(var i = 0; i < this.sheets.length; i++)
                {
                    //Build the name
                    var name = this.sheets[i].data_sheet_name;

                    //Check for a manufacturer
                    if(this.sheets[i].manufacturer_name)
                    {
                        name += ' - ' + this.sheets[i].manufacturer_name;
                    }

                    //Add it
                    options.push({value: this.sheets[i].id, text: name});
                }

                //Send it
                return options;
            },

            selectedSheets(){
                //setup
                var sheets = [];

                //Loop
                for(var i = 0; i < this.sheets.length; i++)
                {
                    //Check if exists in the array
                    if(this.jobsiteSheets.indexOf(this.sheets[i].id) !== -1)
                    {
                        //Add it
                        sheets.push(this.sheets[i]);
                    }
                }

                //Send it
                return sheets;
            },

            JobsiteValues(){
                //check for null
                if(!this.jobsite)
                {
                    return {};
                }

                return this.jobsite;
            },

            scrollHeight(){
                //Setup
                var height = window.innerHeight * 0.5;

                //Send it
                return height;
            },
        },

        methods: {

            refreshTableData(filters) {
                //Set the data
                this.$refs.safetyDataSheetTable.setPage(1);
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.sdsTableFilters.resetColVis(this.$refs.safetyDataSheetTable);
            },

            fetchData(payload){
                //Get the resources
                this.$http.get('/safety-data-sheets/attach', payload)
                    .then(response => {
                        //Set it
                        this.sheets = response.data.sheets;
                        this.catalogs = response.data.catalogs;

                        //Loop
                        for(var i = 0; i < this.sheets.length; i++)
                        {
                            //Check the flag
                            if(this.sheets[i].jobsite_has_sheet == 1)
                            {
                                //Add it
                                this.jobsiteSheets.push(this.sheets[i].id);
                            }
                        }

                        //Check for it
                        if(response.data.jobsite)
                        {
                            this.jobsite = response.data.jobsite;
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            handleShow(bvEvt){
                //Setup
                this.loading = true;
            },

            handleShown(bvEvt){
                //Build the payload
                var payload = {
                    jobsite_id: (this.assetType == 'Jobsite' && this.assetId ? this.assetId : null),
                    data_sheet_id: (this.assetType == 'SafetyDataSheet' && this.assetId ? this.assetId : null),
                };

                //Setup
                this.fetchData(payload);
            },

            //handleOk(bvEvt){
            handleOk(){
                //Stop the close
                //bvEvt.preventDefault();

                //Build the Payload of Sheets
                var sheets = [];

                //Loop and Build
                for (var i = this.sheets.length - 1; i >= 0; i--)
                {
                    //Check if In array
                    if(this.jobsiteSheets.includes(this.sheets[i].id))
                    {
                        //Push the
                        sheets.push({data_sheet_id: this.sheets[i].id, catalog_id: this.sheets[i].catalog_id});
                    }
                }

                //Setup
                this.saving = true;

                //Errors
                this.errors = {};

                //Get the resources
                this.$http.post('/safety-data-sheets/attach', {jobsite_id: this.jobsite.JobsiteId, sheets: sheets})
                    .then(response => {
                        //Alert the User
                        this.$toastr.success('Data Sheet Attached');

                        //Refresh
                        this.$refs.safetyDataSheetTable.refresh();

                        //Close the Modal
                        this.openModal = false;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                        else
                        {
                            this.$toastr.error(error.responseText);
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset
                this.jobsite_id = null;
                this.jobsite = {};
                this.jobsiteSheets = [];
                this.errors = {};
            },

            onJobSiteSelectUpdate(jobsite){
                //Set the jobsite
                this.jobsite = jobsite ? jobsite : null;

                //SEtup
                var payload = {
                    jobsite_id: this.jobsite.JobsiteId,
                    data_sheet_id: null
                };

                //Re-fetch
                this.fetchData(payload);
            },

            exportDataSheets(){
                //Send it
                this.exporting = true;

                //Send it
                this.$http.post('/safety-data-sheets/export/' + this.assetId)
                    .then(response => {
                        //Opend the new file
                        window.location = '/files/download/export/'+response.data;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            this.$toastr.error(error.responseText);
                        }
                    })
                    .then(() => {
                        //Reset
                        this.exporting = false;
                    });
            },

            editCatalog(jobsite_sheet_id){
                //Do what?
                this.edit_jobsite_sheet_id = jobsite_sheet_id;
            },

            updateCatalog(inputVal){
                //Check for NEW
                if(inputVal === 'NEW')
                {
                    //Set the flag
                    this.new_catalog = true;

                    //Stop Here
                    return;
                }
                //Loading?
                this.edit_catalog_loading = true;

                //Send it
                this.$http.post('/jobsites/safety-data-sheets/catalogs/' + this.edit_jobsite_sheet_id, {catalog_id: inputVal, jobsite_sheet_id: this.edit_jobsite_sheet_id})
                    .then(response => {
                        //Alert the User
                        this.$toastr.success('Data Sheet Catalog Updated');

                        //Refresh
                        this.$refs.safetyDataSheetTable.refresh();
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                        else
                        {
                            this.$toastr.error(error.responseText);
                        }
                    })
                    .then(() => {
                        //Reset
                        this.edit_catalog_loading = false;
                    });

                //Call the helper
                this.resetEditCatalog();
            },

            resetEditCatalog(){
                //Reset
                this.edit_jobsite_sheet_id = null;
                this.new_catalog = false;
                this.new_catalog_name = null;
            },

            //Get the Account
            getCatalogs(){
                //Get the data
                this.$http
                    .get('/safety-data-sheets/account')
                    .then(response => {
                        //Set all the data
                        this.catalogs = response.data.catalogs;
                    })
                    .catch(response => {

                    })
                    .then(() => {

                    });
            },

            //Get the Account
            saveNewCatalog(){
                //Get the data
                this.$http
                    .post('/safety-data-sheets/catalogs/edit', {catalog_name: this.new_catalog_name})
                    .then(response => {
                        //Set all the data
                        this.catalogs.push(response.data);

                        //Call the Helper
                        this.updateCatalog(response.data.id);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        //this.resetEditCatalog();
                    });
            },

            toggleSelectAll(){
                //Check the value
                //ITS BACKWARDS BECAUSE OF THE on change event
                if(!this.select_all)
                {
                    //Build ID list
                    var ids = [];

                    //Loop
                    for(var i = 0; i < this.sheets.length; i++)
                    {
                        //Add it
                        ids.push(this.sheets[i].id);
                    }

                    //Check ALL the sheets
                    this.jobsiteSheets = ids;
                }
                else
                {
                    //Uncheck All
                    this.jobsiteSheets = [];
                }
            },
        },

        mounted(){
            //Get Asset type
            if(this.assetType === 'Jobsite')
            {
                //Load the Catalogs
                this.getCatalogs();
            }
        },
    }
</script>